import React from 'react';
import Radium from 'radium';

import SearchInput from 'views/SearchInput';
import {A} from 'views/AppElements';
import AppConstants from 'AppConstants';
import Dropdown from 'muicss/lib/react/dropdown';
import AppUtil from 'AppUtil';


import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu} from 'reactstrap';

const styles = {
    eachNav: { color: '#939598',  textDecoration: 'none', flexGrow: '1', textAlign: 'right',
			'@media (max-width: 770px)': {textAlign: 'center'}},
	dropDownNav: {display: 'block', margin: '0', padding: '5px 10px', ':hover': {background: '#eee'}, textAlign: 'center'},
    navDivider: {margin: '5px 0'},
	searchBtn: {fontSize: '150%', marginLeft: '15px', color: 'rgb(248, 148, 28)', paddingTop: '5px', display: 'block', '@media (max-width: 770px)': {display: 'none'}},
	mobileSearchBtn: {color: 'rgb(248, 148, 28)'}
};

const displayOnlyMobileStyle = {display: 'none', '@media (max-width: 770px)': {display: 'block'}};

export const DropDownNav = ({session}) => {
	const user = session.user;
	const userType = user.userType;

	return <Dropdown label={session.user.username} alignMenu="center">
				{
					(userType === AppConstants.USER_TYPE.DESIGNER 
						|| userType === AppConstants.USER_TYPE.INFLUENCER 
						|| userType === AppConstants.USER_TYPE.PHOTOGRAPHER) &&
					<span>
						<A href="/designer/dashboard" style={[styles.eachNav, styles.dropDownNav]}>Dashboard</A>
						<hr style={styles.navDivider} />
						<A href={AppUtil.getDesignerURL(user)} style={[styles.eachNav, styles.dropDownNav]}>My Page</A>
						<A href="/designer/coupons" style={[styles.eachNav, styles.dropDownNav]}>My Coupons</A>
						
						<A href="/withdrawals" style={[styles.eachNav, styles.dropDownNav]}>Withdrawal History</A>
						<hr style={styles.navDivider} />
					</span>
				}

				{
					userType === AppConstants.USER_TYPE.ADMIN &&
					<span>
						<A href="/order/dashboard" style={[styles.eachNav, styles.dropDownNav]}>Admin Dashboard</A>
						<hr style={styles.navDivider} />
					</span>
				}

				{
					userType === AppConstants.USER_TYPE.SALES &&
					<A href="/order/dashboard" style={[styles.eachNav, styles.dropDownNav]}>All Orders</A>
				}
				
				{
					userType !== AppConstants.USER_TYPE.SALES &&
					<A href="/orders" style={[styles.eachNav, styles.dropDownNav]}>My Orders</A>
				}

				<hr style={styles.navDivider} />
				<A href="/settings" style={[styles.eachNav, styles.dropDownNav]}>Settings</A>
				<A href="/logout" style={[styles.eachNav, styles.dropDownNav]}>Logout</A>
			</Dropdown>;

};


export const NavBarContent = Radium(({influencers, popularStores, onCloseClick}) => {


	function createDropDowns(title, menuItems) {
		return <UncontrolledDropdown nav inNavbar>
	                <DropdownToggle nav caret>
	                  {title}
	                </DropdownToggle>
	                <DropdownMenu>
	                	{menuItems}
	                </DropdownMenu>
              </UncontrolledDropdown>
	}

	const influencersLinks = !influencers? []: influencers.map(i => <A key={i.username} className="dropdown-item" href={AppUtil.getDesignerURL(i)}>{i.username}</A>);
	const influencersDropDown = createDropDowns("Influencers", influencersLinks);

	const ARTISTS = AppConstants.TOP_ARTISTS.map(u => <A key={u.username} className="dropdown-item" href={AppUtil.getDesignerURL(u)}>{u.username}</A>);
	ARTISTS.push(<A key="All Artists" style={{color: 'orange'}} className="dropdown-item" href="/artist/all">View All</A>);
	const artistsDropDown = createDropDowns("Artists", ARTISTS);

	let storeLinks = !popularStores? []: popularStores.map(s => <A key={s.storeName} className="dropdown-item" href={AppUtil.getDesignerURL(s)}>{s.storeName}</A>).toArray();
	storeLinks.push(<A key="All Stores" style={{color: 'orange'}} className="dropdown-item" href="/stores/all">View All</A>);

	const storesDropDown = createDropDowns("Top Stores", storeLinks);
	
	
	const PRODUCT_TYPES = Object.keys(AppConstants.PRODUCT_TYPES)
								.map(k => AppConstants.PRODUCT_TYPES[k])
								.filter(p => p.available === true)
								.map(p => <A key={p.val} className="dropdown-item" href={"/shop/"+p.url}>{p.label}</A>);

	const shopDropdowns = createDropDowns("Shop", PRODUCT_TYPES);

	return <Nav navbar>

			{
				onCloseClick !== undefined && 
				<NavItem>
					<A href="#" onClick={onCloseClick} className="closeNavBar"><i className="fa fa-times" aria-hidden="true"></i></A>									
				</NavItem>
			}
			
			<NavItem>
				<A href="/">Home</A>									
			</NavItem>

			<NavItem>
				<A href="/custom-order/music-plaque" className="musicPlaqueNav"><i className="fa fa-music rotateClockWise" style={{color: '#f8951b'}} aria-hidden="true"></i> Music Plaque <i className="fa fa-music rotateAntiClockWise" style={{color: '#f8951b'}} aria-hidden="true"></i></A>									
			</NavItem>

			<NavItem>
				<A href="/custom-order/photo-frame" className="photoFrameNav">
						<span>[ </span>Frame your Photo<span> ]</span>
				</A>
			</NavItem>

			{shopDropdowns}
			{influencersDropDown}
			{artistsDropDown}
			{storesDropDown}

			<NavItem>
				<hr style={styles.navDivider} />
			</NavItem>
			

			<div style={displayOnlyMobileStyle}>
				<NavItem>
					<A href={AppConstants.FB_PAGE} style={{letterSpacing: '1px', textTransform: 'uppercase'}} className="facebookNav">
						<i className="fa fa-facebook-official" aria-hidden="true"
						style={{color: '#4267b1', fontWeight: 'bold'}}></i> Facebook
					</A> 							
				</NavItem>
				<NavItem>
					<A href={AppConstants.INSTA_PAGE} className="instagramNav">
						<i className="fa fa-instagram" aria-hidden="true" 
							style={{color: '#f8941c', fontWeight: 'bold'}}></i> INSTAGRAM</A>
				</NavItem>

				<NavItem style={{padding: '0'}}>
					<SearchInput keyword={""} btnStyle={styles.mobileSearchBtn} />
				</NavItem>
			</div>

			<NavItem style={{padding: '0'}}>
				<A href={"/search/"} style={styles.searchBtn}><i className="fa fa-search" aria-hidden="true"></i></A>
			</NavItem>
		</Nav>
});
    
class AppMenu extends React.Component {
	constructor(props) {
    	super(props);

	    this.toggle = this.toggle.bind(this);
	    this.state = {
	      isOpen: false
	    };
	}

	toggle() {
    	this.setState({
      		isOpen: !this.state.isOpen
    	});
	}

	render() {
		const defaultLogoStyle = {cursor: 'pointer', width: '80%', margin: '0 auto'};

		//show sticky logo only in web, because by default, the logo is visible in mobile
		const desktopStickyLogoStyle = {display: 'none', '@media (min-width: 770px)': {position: 'absolute', top: '5px', left: '160px', display: 'block', height: '49px', cursor: 'pointer'}};

		const logoImg = AppUtil.getAppLogo();
		const iconImg = AppUtil.getAppIcon();
		return (<div style={this.props.style} id="headerNavigation">
					{AppUtil.isDashainRunning() &&
						<div style={{background: '#f8941c', padding: '5px', textAlign: 'center', color: 'white', fontSize: '14px', borderTop: '1px solid white'}}>
							<span>Happy Dashain! All orders will be processed after Oct 13, 2019. </span>
							<br />
							<span>For any inquiry, call {AppConstants.CONTACT_NUMBER}.</span>
						</div>
					}

					<Navbar color="light" light expand="md">
						<NavbarBrand href="/">					
							<img src={iconImg} alt="Seto Canvas" style={[this.props.isSticky? desktopStickyLogoStyle: {display: 'none'}]} />

							<img src={logoImg} alt="Seto Canvas" style={[displayOnlyMobileStyle, defaultLogoStyle]} />
						
						</NavbarBrand>
			          	<NavbarToggler onClick={this.props.onNavBarToggle} />
						
						

			            <Collapse isOpen={this.state.isOpen} navbar>
				            <NavBarContent influencers={this.props.influencers} popularStores={this.props.popularStores}/>
			          	</Collapse>

						
			        </Navbar>	

				</div>)
	}
}

AppMenu = Radium(AppMenu);

export default AppMenu;


// WEBPACK FOOTER //
// ./src/views/AppMenu.js